import { render, staticRenderFns } from "./SlideCarousel.vue?vue&type=template&id=24c32ae8&scoped=true"
import script from "./SlideCarousel.vue?vue&type=script&lang=js"
export * from "./SlideCarousel.vue?vue&type=script&lang=js"
import style0 from "./SlideCarousel.vue?vue&type=style&index=0&id=24c32ae8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c32ae8",
  null
  
)

export default component.exports